(function () {
  'use strict';
  // SULTANEA15 is manual. Old Shopify carts can retain codes that become
  // applicable only when the shopper adds another perfume.
  var CODE='SULTANEA15';
  var KEY='sultanea15_manual_cart_v2';
  var AGE=30*24*3600*1000;
  var busy=false,again=false,timer=null;
  function route(){return ((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/').replace(/\/?$/,'/');}
  function norm(x){return String(x||'').replace(/\s+/g,'').toUpperCase();}
  function cartToken(x){return String(x||'').split('?')[0];}
  function codes(cart){
    var found=[];
    (Array.isArray(cart.discount_codes)?cart.discount_codes:[]).forEach(function(x){
      var code=typeof x==='string'?x:String(x&&x.code||'');
      if(code&&found.indexOf(code)<0)found.push(code);
    });
    // Some Shopify cart responses present applied codes as allocations only.
    var applications=Array.isArray(cart.cart_level_discount_applications)?cart.cart_level_discount_applications:[];
    (Array.isArray(cart.items)?cart.items:[]).forEach(function(item){
      (Array.isArray(item.line_level_discount_allocations)?item.line_level_discount_allocations:[]).forEach(function(x){
        if(x.discount_application)applications.push(x.discount_application);
      });
    });
    applications.forEach(function(x){
      if(x&&x.type==='discount_code'&&x.title&&found.indexOf(x.title)<0)found.push(x.title);
    });
    return found;
  }
  function fetchCart(){
    return fetch(route()+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json'}})
      .then(function(x){if(!x.ok)throw Error('cart unavailable');return x.json();});
  }
  function getMark(){try{return JSON.parse(localStorage.getItem(KEY)||'null');}catch(_){return null;}}
  function clearMark(){try{localStorage.removeItem(KEY);}catch(_){}}
  function markedFor(cart){
    var x=getMark();
    return !!(x&&x.token&&x.token===cartToken(cart.token)&&Number.isFinite(x.at)&&Date.now()>=x.at&&Date.now()-x.at<AGE);
  }
  function markApplied(tok){
    if(!tok){fetchCart().then(function(c){markApplied(c.token);}).catch(function(){});return;}
    try{localStorage.setItem(KEY,JSON.stringify({token:cartToken(tok),at:Date.now()}));}catch(_){}
  }
  window.SultaneaManualCodeGuard={
    markApplied:markApplied,
    clearAuthorization:clearMark,
    check:function(){schedule(90);}
  };
  function schedule(ms){
    if(timer!==null)clearTimeout(timer);
    timer=setTimeout(function(){timer=null;check();},ms||260);
  }
  function updateVisibleCart(){
    var onCart=/\/cart\/?$/.test(location.pathname);
    var openDrawer=document.querySelector('cart-drawer[open],cart-drawer[aria-expanded="true"],dialog[open] cart-items-component');
    if(!onCart&&!openDrawer)return;
    // One refresh at most prevents a cookie or third-party app from creating a reload loop.
    try{
      if(sessionStorage.getItem('sultanea15_stale_refresh_v2')==='1')return;
      sessionStorage.setItem('sultanea15_stale_refresh_v2','1');
    }catch(_){}
    location.reload();
  }
  function check(){
    if(busy){again=true;return;}
    busy=true;
    fetchCart().then(function(cart){
      var count=Number(cart.item_count||0);
      if(count<=0)clearMark();
      var all=codes(cart),contains=all.some(function(x){return norm(x)===CODE;});
      if(!contains||count>0&&markedFor(cart))return;
      var others=all.filter(function(x){return norm(x)!==CODE;});
      return fetch(route()+'cart/update.js',{
        method:'POST',credentials:'same-origin',cache:'no-store',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({discount:others.join(',')})
      }).then(function(res){if(!res.ok)throw Error('Cannot clear old discount');return res.json();})
        .then(function(updated){
          if(codes(updated).some(function(x){return norm(x)===CODE;}))return;
          clearMark();
          updateVisibleCart();
        });
    }).catch(function(){
      // Avoid changing other offers if Shopify is temporarily unavailable.
    }).finally(function(){
      busy=false;
      if(again){again=false;schedule(450);}
    });
  }
  document.addEventListener('cart:update',function(){schedule(450);});
  document.addEventListener('discount:update',function(){schedule(450);});
  document.addEventListener('quantity-selector:update',function(){schedule(1100);});
  window.addEventListener('pageshow',function(){schedule(180);});
  document.addEventListener('visibilitychange',function(){if(!document.hidden)schedule(400);});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){schedule(120);});
  else schedule(120);
})();